/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Ledger_Note_ApprovedInputs */

const vi_error_ledger_note_approved = /** @type {(inputs: Error_Ledger_Note_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập kho của mẻ này đã duyệt nên dòng sổ đã khoá, không sửa được số lượng, lô hay sản phẩm nữa.`)
};

/**

* @param {Error_Ledger_Note_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_ledger_note_approved = /** @type {((inputs?: Error_Ledger_Note_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Ledger_Note_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_ledger_note_approved(inputs)
});